import { useMediaQuery } from "@mui/material";
import { useCallback, useState } from "react";
import { useSelector } from "react-redux";
import { getPermissionFlags } from "utils/permissions";

export const useUserAdmin = () => {
  const isLargeScreen = useMediaQuery("(min-width:1000px)");

  const user = useSelector((state) => state.user);

  const { showLocation } = getPermissionFlags(user);

  const [open, setOpen] = useState(false);
  const [editMode, setEditMode] = useState(false); // Track if we are in edit mode
  const [currentUser, setCurrentUser] = useState(null); // Store the user being edited

  const handleOpen = useCallback(() => {
    setEditMode(false);
    setCurrentUser(null);
    setOpen(true);
  }, []);

  const handleEditOpen = useCallback((user) => {
    setEditMode(true);
    setCurrentUser(user);
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  return {
    isLargeScreen,
    open,
    editMode,
    currentUser,
    handleOpen,
    handleEditOpen,
    handleClose,
    setOpen,
    showLocation,
  };
};
